import { combineReducers } from "@reduxjs/toolkit";
import transactions from "reducers/transactions";
import dashboard from "reducers/dashboard";
import dashboardSlotCapacity from "reducers/dashboardSlotCapacityModal";
import detailTransaction from "reducers/detailTransaction";
import pickers from "./pickers";
import detailPicker from "reducers/detailPicker";
import login from "./login";
import notification from "reducers/notification";
import preliquidations from "reducers/preliquidation";
import { connectRouter } from "connected-react-router";
import storageSession from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";
import rainModal from "./rainModal";
import regions from "./regions";
import session from "./session";
import slots from "reducers/slots";
import slotCreation from "reducers/slotCreation";
import slotTemplateModal from "reducers/slotTemplateModal";
import slotDetail from "reducers/slotDetailModal";
import slotTemplates from "reducers/slotTemplates";
import termsAndConditions from "reducers/termsAndConditions";

import { RouteComponentProps } from "react-router-dom";
import { createBrowserHistory } from "history";

const persistConfig = {
  key: "root",
  whitelist: [],
  storage: storageSession,
};

const dashboardConfig = {
  key: "dashboard",
  whitelist: ["filters"],
  storage: storageSession,
};

const pickersConfig = {
  key: "pickers",
  whitelist: ["actualPage"],
  storage: storageSession,
};

const regionsConfig = {
  key: "regions",
  whitelist: ["filters"],
  storage: storageSession,
};

const preliquidationsConfig = {
  key: "preliquidations",
  whitelist: [
    "filters",
    "filtersExtra",
    "filtersExtraSeeMore",
    "pendingApprovalPresettlements",
    "currentInvoice",
  ],
  storage: storageSession,
};

const sessionConfig = {
  key: "session",
  blacklist: ["loadersCount"],
  storage: storageSession,
};

const slotsConfig = {
  key: "slots",
  whitelist: ["filters", "actualPage", "actualRegion"],
  storage: storageSession,
};

const slotTemplatesConfig = {
  key: "slotTemplates",
  whitelist: ["filters", "actualRegion"],
  storage: storageSession,
};

const termsAndConditionsConfig = {
  key: "termsAndConditions",
  blacklist: ["fileStatus", "loading", "error", "currentFile"],
  storage: storageSession,
};

export const history = createBrowserHistory();

const rootReducer = (history: RouteComponentProps["history"]) =>
  combineReducers({
    router: connectRouter(history),
    session: persistReducer(sessionConfig, session),
    pickers: persistReducer(pickersConfig, pickers),
    transactions,
    dashboard: persistReducer(dashboardConfig, dashboard),
    dashboardSlotCapacity,
    detailPicker,
    login,
    slots: persistReducer(slotsConfig, slots),
    slotCreation,
    notification,
    detailTransaction,
    preliquidations: persistReducer(preliquidationsConfig, preliquidations),
    regions: persistReducer(regionsConfig, regions),
    slotDetail,
    slotTemplateModal,
    slotTemplates: persistReducer(slotTemplatesConfig, slotTemplates),
    rainModal,
    termsAndConditions: persistReducer(termsAndConditionsConfig, termsAndConditions),
  });
const persistedReducer = persistReducer(persistConfig, rootReducer(history));
export default persistedReducer;
